/*
 * Slide Templates — turns a set of selected template ids into slides in the
 * deck. Thin wrapper around shared/services/pptxTemplateSlideInsert.ts's
 * `insertTemplateSlides` (source-file grouping, sub-deck building, insert
 * loop — identical to Presentation Templates' own need, see that module's
 * header) with this feature's own messages/telemetry reasons. Shared by both
 * callers so the ordering/partial-failure rules live in one place:
 *
 *   - hooks/useSlideTemplates.ts — the in-pane Asset Library, where the panel
 *     holds the full manifest itself.
 *   - asset-library/hooks/useAssetLibraryLauncher.ts — the dialog flow, where
 *     the pane holds the manifest and the ids come back over messageParent.
 */

import { insertTemplateSlides } from "../../shared/services/pptxTemplateSlideInsert";
import { logSlideTemplatesError, type SlideTemplate } from "./slideTemplatesApi";

export const NO_INSERTABLE_SELECTION_MESSAGE = "None of the selected templates have insertable slide content yet.";
const SOURCE_DOWNLOAD_FAILED_MESSAGE = "Downloading this template's source file failed.";

/**
 * Inserts the selected templates, in the order the manifest lists them.
 *
 * @returns how many slides were inserted.
 */
export async function insertSlideTemplates(
  templates: readonly SlideTemplate[],
  selectedIds: readonly string[],
): Promise<number> {
  return insertTemplateSlides(
    templates,
    selectedIds,
    { noInsertableSelection: NO_INSERTABLE_SELECTION_MESSAGE, sourceDownloadFailed: SOURCE_DOWNLOAD_FAILED_MESSAGE },
    { log: logSlideTemplatesError, reasonPrefix: "slide-templates" },
  );
}
